module.exports = __webpack_public_path__ + "static/guitar-shop-e59e32c0c297f724ea4a4d53113635f1.jpg";